import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { FileText, CheckCircle, Funnel, DownloadSimple } from "@phosphor-icons/react";

const DIFF_COLOR = { facile: "#2E7D32", moyen: "#FFB800", difficile: "#D32F2F" };

export default function Archive() {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const [exams, setExams] = useState([]);
  const [filter, setFilter] = useState("all");

  useEffect(() => {
    api.get("/exams").then((r) => setExams(r.data));
    api.get("/archive").then((r) => setItems(r.data));
  }, []);

  const filtered = filter === "all" ? items : items.filter((i) => i.exam_id === filter);
  const examName = (id) => exams.find((e) => e.id === id)?.name || id;

  return (
    <div className="space-y-8">
      <div className="animate-fade-up">
        <h1 className="font-display text-3xl font-extrabold sm:text-4xl">Banque de sujets</h1>
        <p className="mt-1 text-ink/65">Sujets d'examens classés par année, série et difficulté, avec corrigés.</p>
      </div>

      <div className="flex flex-wrap items-center gap-2">
        <span className="inline-flex items-center gap-1.5 text-sm font-medium text-muted-foreground"><Funnel size={16} /> Filtrer :</span>
        <button data-testid="filter-all" onClick={() => setFilter("all")} className={`rounded-full px-3.5 py-1.5 text-sm font-medium transition ${filter === "all" ? "bg-terracotta text-white" : "border border-border bg-white hover:bg-sand"}`}>Tous</button>
        {user?.exam_id && (
          <button data-testid="filter-mine" onClick={() => setFilter(user.exam_id)} className={`rounded-full px-3.5 py-1.5 text-sm font-medium transition ${filter === user.exam_id ? "bg-terracotta text-white" : "border border-border bg-white hover:bg-sand"}`}>{examName(user.exam_id)}</button>
        )}
      </div>

      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {filtered.map((it, i) => (
          <div key={i} data-testid={`archive-${i}`} className="group rounded-2xl border border-border bg-white p-5 transition hover:-translate-y-1 hover:shadow-[0_14px_34px_rgba(4,42,101,0.1)]">
            <div className="flex items-start justify-between">
              <div className="grid h-11 w-11 place-items-center rounded-xl bg-forest/10 text-forest"><FileText size={24} weight="duotone" /></div>
              <span className="rounded-full px-2.5 py-0.5 text-xs font-semibold text-white" style={{ background: DIFF_COLOR[it.difficulty] }}>{it.difficulty}</span>
            </div>
            <div className="mt-4 font-display text-lg font-bold">{it.title}</div>
            <div className="mt-1 text-sm text-muted-foreground">{examName(it.exam_id)} · {it.subject} · Série {it.series}</div>
            <div className="mt-4 flex items-center justify-between">
              {it.has_correction
                ? <span className="inline-flex items-center gap-1 text-sm font-medium text-forest"><CheckCircle weight="fill" size={16} /> Corrigé inclus</span>
                : <span className="text-sm text-muted-foreground">Corrigé bientôt</span>}
              <Link to="/app/tuteur" className="inline-flex items-center gap-1 text-sm font-semibold text-terracotta hover:underline"><DownloadSimple size={16} /> Travailler</Link>
            </div>
          </div>
        ))}
        {!filtered.length && <p className="col-span-full py-8 text-center text-sm text-muted-foreground">Aucun sujet pour ce filtre.</p>}
      </div>
    </div>
  );
}
